export function estMedecin(roles) {
    return Array.isArray(roles) && roles.some(role => role.nom === 'ROLE_MEDECIN')
}

export function remunerationActe(base, taux) {
    return Math.round(Number(base) * Number(taux) / 100)
}

export function remunerationFixe(montant) {
    return Math.round(Number(montant))
}

const LIBELLES_CATEGORIES = {
    consultation: 'Consultations',
    analyse: 'Analyses',
    examen: 'Examens',
    chirurgie: 'Chirurgie',
    // Codes historiques des actes facturables, conservés pour les règles/API.
    soin: 'Actes',
    soins: 'Actes',
    medicament: 'Médicaments'
}

export function libelleCategorie(categorie) {
    return LIBELLES_CATEGORIES[categorie] || categorie || '—'
}

export function normaliserIdPrestation(value) {
    if (value === null || value === undefined || value === '' || Number(value) === 0) return null
    const id = Number(value)
    return Number.isFinite(id) ? id : null
}

/**
 * The V3 endpoint exposes a flat, category-tagged catalogue. Keep the
 * grouping at the UI boundary so each newly activated category does not need
 * another rendering rewrite.
 */
export function normaliserCatalogueRemuneration(catalogue) {
    const groupes = []
    const parCategorie = {}
    const ajouter = (categorie, libelle, prestations) => {
        const code = categorie || 'consultation'
        if (!parCategorie[code]) {
            parCategorie[code] = {
                categorie: code,
                // Un ancien catalogue peut encore fournir le libellé « Soins ».
                libelle: ['soin', 'soins'].includes(code) ? libelleCategorie(code) : libelle || libelleCategorie(code),
                prestations: []
            }
            groupes.push(parCategorie[code])
        }
        const listePrestations = prestations || []
        listePrestations.forEach(prestation => {
            if (!prestation || normaliserIdPrestation(prestation.id) === null) return
            const id = normaliserIdPrestation(prestation.id)
            if (!parCategorie[code].prestations.some(item => item.id === id)) {
                parCategorie[code].prestations.push(Object.assign({}, prestation, { id }))
            }
        })
    }

    ;(Array.isArray(catalogue) ? catalogue : []).forEach(item => {
        if (!item) return
        if (Array.isArray(item.prestations)) {
            ajouter(item.categorie || item.prestation_type, item.libelle, item.prestations)
            return
        }
        ajouter(item.categorie || item.prestation_type, item.categorie_libelle, [item])
    })
    return groupes
}

export function estRegleV3(regle) {
    return !!regle && Number(regle.schema_version || 1) >= 3
}

const valeur = value => String(value === null || value === undefined ? '' : value).trim()
export function montantEntierValide(value) {
    return /^(0|[1-9][0-9]{0,12})$/.test(valeur(value)) && Number(valeur(value)) <= 9999999999999
}

export function tauxValide(value) {
    return /^(0|[1-9][0-9]{0,2})(\.[0-9]{1,2})?$/.test(valeur(value)) && Number(valeur(value)) <= 100
}

export function erreurRegleV3(regle, categorie, prestation) {
    if (!categorie) return 'Choisissez une catégorie.'
    const prestationId = normaliserIdPrestation(regle.prestation_id)
    if (prestationId !== null && !prestation) return 'Choisissez un type tarifé dans cette catégorie.'

    if (regle.mode_remuneration === 'pourcentage') {
        if (!tauxValide(regle.pourcentage)) return 'Le taux doit être compris entre 0 et 100 %, avec deux décimales au maximum.'
        if (valeur(regle.montant_fixe)) return 'Le montant fixe ne s’applique pas à une règle au pourcentage.'
        if (prestation) {
            if (!montantEntierValide(regle.base_remuneration)) return 'La base doit être un montant entier positif ou nul.'
            if (Number(valeur(regle.base_remuneration)) > Number(prestation.montant)) return 'La base ne peut pas dépasser le P.U. du type choisi.'
        } else if (valeur(regle.base_remuneration)) {
            return 'La base est disponible uniquement pour un type précis.'
        }
        return ''
    }

    if (regle.mode_remuneration === 'montant_fixe') {
        if (!montantEntierValide(regle.montant_fixe)) return 'Le montant fixe doit être un montant entier positif ou nul.'
        if (valeur(regle.pourcentage) || valeur(regle.base_remuneration)) return 'Le pourcentage et la base ne s’appliquent pas à une règle au montant fixe.'
        return ''
    }

    return 'Choisissez un mode de rémunération.'
}

export function erreurRegle(regle, prestation) {
    if (!prestation) return 'Choisissez une consultation.'
    if (prestation.montant === null || prestation.montant === undefined) {
        return "Définissez d'abord le tarif de cette consultation."
    }
    const taux = String(regle.pourcentage)
    if (!/^\d+(\.\d{1,2})?$/.test(taux) || Number(taux) > 100) {
        return 'Le taux doit être compris entre 0 et 100 %, avec deux décimales au maximum.'
    }
    const base = String(regle.base_remuneration)
    if (!/^\d+$/.test(base) || Number(base) > Number(prestation.montant)) {
        return 'La base doit être un entier compris entre 0 et le montant de la prestation.'
    }
    return ''
}

export function messageErreur(error) {
    const data = error && error.response && error.response.data
    if (data && data.errors) {
        const messages = Object.keys(data.errors).map(key => data.errors[key][0])
        if (messages.length) return messages.join(' ')
    }
    return data && data.message ? data.message : 'Impossible de joindre le service. Réessayez.'
}
